import CommentIcon from '@mui/icons-material/Comment';
import Grid3x3Icon from '@mui/icons-material/Grid3x3';
import InfoIcon from '@mui/icons-material/Info';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';

import TabsOrganize, { TabT } from 'shared/components/TabsOrganize';
import ViewDetails from 'shared/containers/ViewDetails';
import { GENERAL_INFO_TITLE, SETTINGS_TITLE, ViewDetailsT } from 'shared/containers/ViewDetails/ViewDetails';
import SCHCTemplate from 'shared/models/SCHCTemplate';
import { generateRandomString } from 'utils/string';

import './SCHCTemplatesDetailsRender.scss';

import SCHCTemplatesDetailsRenderCompression from './SCHCTemplatesDetailsRender.compression';
import SCHCTemplatesDetailsRenderFragmentation from './SCHCTemplatesDetailsRender.fragmentation';

type SCHCTemplatesDetailsRenderProps = {
  data: SCHCTemplate.API.BodyT;
}
function SCHCTemplatesDetailsRender({ data }: SCHCTemplatesDetailsRenderProps) {
  const dataStructureMain: ViewDetailsT = {
    sections: [
      {
        title: GENERAL_INFO_TITLE,
        items: [
          {
            type: 'name',
          },
          {
            type: 'creation',
          },
          {
            label: 'SCHC Template ID',
            dataPath: 'sCHCTemplateID',
            icon: <Grid3x3Icon color="primary" />,
          },
          {
            type: 'update',
          },
          {
            label: 'Description',
            dataPath: 'description',
            icon: <CommentIcon color="primary" />,
          },
          {
            label: 'Nb device profiles',
            dataPath: 'nbDeviceProfiles',
          },
        ],
        shape: 2,
      },
      {
        title: SETTINGS_TITLE,
        items: [
          {
            label: 'LoRaWAN (Payload with Rule ID)',
            dataPath: 'unruly',
          },
          {
            label: 'Legacy',
            dataPath: 'legacy',
          },
        ],
        shape: 1,
      },
    ],
  };

  const dataStructureRules: ViewDetailsT = {
    sections: [
      {
        items: [
          {
            label: 'Non-matching Rule ID',
            dataPath: 'nonMatchingRule',
          },
        ],
        shape: 1,
      },
    ],
  };

  const tabsContent: TabT[] = [
    {
      label: 'Details',
      name: 'details',
      content: (
        <div className="scroll">
          <ViewDetails dataStructure={dataStructureMain} data={data} />
        </div>
      ),
      icon: <InfoIcon />,
      iconPosition: 'start',
    },
    {
      label: `Rules · ${data.deviceSchcRules?.length || 'None'}`,
      name: 'rules',
      content: (
        <div className="schc-templates-render scroll">
          <ViewDetails dataStructure={dataStructureRules} data={data} />
          {
            data.deviceSchcRules?.map((rule) => {
              switch (rule.ruleType) {
                case SCHCTemplate.COMPRESSION_RULE:
                  return (
                    <SCHCTemplatesDetailsRenderCompression
                      key={generateRandomString()}
                      data={rule.compressionRule}
                    />
                  );
                case SCHCTemplate.FRAGMENTATION_RULE:
                  return (
                    <SCHCTemplatesDetailsRenderFragmentation
                      key={generateRandomString()}
                      data={rule.fragmentationRule}
                    />
                  );
                default:
                  return null;
              }
            })
          }
        </div>
      ),
      icon: <PlaylistAddCheckIcon />,
      iconPosition: 'start',
    },
  ];

  if (!data) {
    return null;
  }
  return <TabsOrganize tabs={tabsContent} />;
}

export default SCHCTemplatesDetailsRender;
